import { AxiosError } from 'axios';
import { Typography } from '@mui/material';
import { MRT_RowData } from 'material-react-table';
import { UseQueryResult } from '@tanstack/react-query';

import {
  CasErrorDisplay,
  CasMRTable,
  CasMRTCellRenderCurrrency,
  CasMRTCellRenderDate,
  CasMRTCellRenderNumberWithCommas,
  ModifiedMRT_ColumnDef,
} from 'src/compass/shared/components';
import CasLoader from 'src/compass/shared/components/CasLoader/CasLoader';

import { DateFormat, formatDate } from 'src/compass/shared/util/casMoment';

import { PreliminaryCommissionsTopToolbar } from 'src/compass/application/commissions';

type UnpaidCommissionsProps = {
  queryResult: UseQueryResult<any, AxiosError>;
  exportUrl: string;
  exportParams?: Record<string ,any>
};

export default function UnpaidCommissions({ queryResult, exportUrl, exportParams }: UnpaidCommissionsProps) {
  const columns: ModifiedMRT_ColumnDef<MRT_RowData>[] = [
    {
      accessorKey: 'endMonth',
    },
    {
      accessorKey: 'unpaidCommission',
      Cell: CasMRTCellRenderCurrrency,
      aggregationFn: 'sum',
      AggregatedCell: CasMRTCellRenderCurrrency,
    },
    {
      accessorKey: 'effectiveDate',
      Cell: CasMRTCellRenderDate,
    },
    {
      accessorKey: 'reinsuranceYear',
    },
    {
      accessorKey: 'policyNumber',
      header: 'Policy',
    },
    {
      accessorKey: 'sce',
      header: 'SCE#',
    },
    {
      accessorKey: 'insuredName',
      header: 'Insured',
    },
    {
      accessorKey: 'endDate',
      Cell: CasMRTCellRenderDate,
    },
    {
      accessorKey: 'headCount',
      header: 'HC',
      Cell: CasMRTCellRenderNumberWithCommas,
    },
    {
      accessorKey: 'basePremium',
      header: 'Premium',
      Cell: CasMRTCellRenderCurrrency,
    },
    {
      accessorKey: 'description',
    },
    {
      accessorKey: 'rate',
    },
    {
      accessorKey: 'adjustedYear',
      header: 'Adjusted',
    },
    {
      accessorKey: 'commissionAccrued',
      header: 'Commission',
      Cell: CasMRTCellRenderCurrrency,
    },
    {
      accessorKey: 'crop',
    },
  ];

  const { data, isFetching, isError, error } = queryResult;

  if (isFetching) return <CasLoader />;
  if (isError) return <CasErrorDisplay message={error.message} />;

  const formattedThroughDate = formatDate(data.currentPeriodThrough, DateFormat.MDY);

  return (
    <>
      <Typography>Through {formattedThroughDate}</Typography>
      <CasMRTable
        queryResult={queryResult}
        columns={columns}
        initialState={{
          grouping: ['endMonth'],
        }}
        enableExpanding
        onGroupingChange={() => {}}
        enablePagination={false}
        renderTopToolbarCustomActions={() => (
          <PreliminaryCommissionsTopToolbar
            total={data?.total}
            totalLabel="Total Unpaid Commissions"
            exportUrl={exportUrl}
            exportParams={exportParams}
          />
        )}
        hideGroupingHeader
      />
    </>
  );
}
